import React, { useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { FaGavel, FaBriefcase, FaUsers, FaHome, FaBalanceScale, FaBuilding, FaMoneyBill, FaLandmark, FaPassport, FaShip, FaHandshake, FaLightbulb, FaFileContract, FaUserShield, FaUserMd, FaShieldAlt, FaLaptopCode, FaDatabase } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const DynamicCardSectionHome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  }, []);

  const cardData = [
    
    {
      title: "İş Hukuku",
      icon: <FaBriefcase size={30} color="#ff6347" />,
      link: "/ozel-hukuk/is-hukuku",
    },
    {
      title: "Aile Hukuku",
      icon: <FaUsers size={30} color="#4682b4" />,
      link: "/ozel-hukuk/aile-hukuku",
    },
    {
      title: "Fikri Mülkiyet Hukuku",
      icon: <FaLightbulb size={30} color="#6a5acd" />,
      link: "/ticaret-hukuku/fikri-mulkiyet-hukuku",
    },
    {
      title: "Gayrimenkul Hukuku",
      icon: <FaBuilding size={30} color="#20b2aa" />,
      link: "/ozel-hukuk/gayrimenkul-hukuku",
    },
    {
      title: "Ticaret Hukuku",
      icon: <FaHandshake size={30} color="#daa520" />,
      link: "/ticaret-hukuku/ticaret-hukuku",
    },
    {
      title: "Ceza Hukuku",
      icon: <FaBalanceScale size={30} color="#ffa07a" />,
      link: "/kamu-hukuku/ceza-hukuku",
    },

    {
      title: "Tüketici Hukuku",
      icon: <FaUserShield size={30} color="#ff4500" />,
      link: "/tuketici-ve-saglik-hukuku/tuketici-hukuku",
    },
    {
      title: "Sağlık Hukuku",
      icon: <FaUserMd size={30} color="#20b2aa" />,
      link: "/tuketici-ve-saglik-hukuku/saglik-hukuku",
    },
    {
      title: "Sigorta Hukuku",
      icon: <FaShieldAlt size={30} color="#ff6347" />,
      link: "/tuketici-ve-saglik-hukuku/sigorta-tahkim-hukuku",
    },
    {
      title: "Sözleşme Hukuku",
      icon: <FaFileContract size={30} color="#123274" />,
      link: "/ozel-hukuk/sozlesmeler-ve-borclar-hukuku",
    },
    {
      title: "İdare Hukuku",
      icon: <FaLandmark size={30} color="#ff4500" />,
      link: "/kamu-hukuku/idare-hukuku",
    },
  
    {
      title: "KVKK",
      icon: <FaDatabase size={30} color="#2e8b57" />,
      link: "/teknoloji-ve-verilerin-korunmasi-hukuku/kisisel-verilerin-korunmasi-hukuku",
    },
  ];

  return (
    <div style={{ backgroundColor: "#f4f5f7", padding: "60px 0" }}>
      <Container>
        <h2
          className="text-center mb-5"
          style={{ color: "#2c3e50", fontFamily: "Arial, sans-serif", fontWeight: "bold" }}
          data-aos="fade-up"
        >
          Uzmanlık Alanlarımız
        </h2>
        <Row className="g-4">
          {cardData.map((card, index) => (
            <Col
              lg="4"
              md="6"
              sm="12"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div
                className="p-4 shadow rounded-3 bg-white text-center hover-effect"
                style={{ cursor: "pointer", transition: "transform 0.3s, box-shadow 0.3s" }}
                onClick={() => navigate(card.link)}
              >
                <div className="mb-3">{card.icon}</div>
                <h5 style={{ color: "#2c3e50", fontWeight: "bold" }}>{card.title}</h5>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default DynamicCardSectionHome;
